const initialState = {
  isAuth: false,
  name: "Marcus",
  userPreferences: {},
};

export default function user(state = initialState, action) {
  let newState = Object.assign({}, state);

  switch (action.type) {
    case "CHECK_LOGIN":
      let _user = window.localStorage.getItem("_user");

      if (_user) {
        _user = JSON.parse(_user);
        newState.isAuth = _user.token.length !== 0;
        newState.username = _user.username;
      }

      break;

    case "LOGIN":
      if ("credentials" in action.payload) {
        window.localStorage.setItem(
          "_user",
          JSON.stringify(action.payload.credentials)
        );
        newState.isAuth = true;
      }

      break;

    case "LOGOUT":
      window.localStorage.clear();
      newState.isAuth = true;

      break;

    case "SET_USER_PREFERENCES":
      newState.userPreferences = action.payload;
      window.localStorage.setItem(
        "_user_preferences",
        JSON.stringify(action.payload)
      );
      break;
    default:
      return state;
  }

  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/user.reducer.js